import type { AllowedSidebarNavItem } from '@/shared/hooks/useNavigation'
import type { ModuleNavItem } from '@/modules'

export type AppMenuNavGroup = 'principal' | 'suporte'

const APP_MENU_LABEL_OVERRIDES: Record<string, string> = {
  faq: 'Central de Ajuda',
  forum: 'Feed Social'
}

const SUPPORT_SLUGS = new Set(['faq'])

export function getAppMenuDisplayName(item: ModuleNavItem | AllowedSidebarNavItem) {
  return APP_MENU_LABEL_OVERRIDES[item.slug] ?? item.name
}

export function getAppMenuNavGroup(
  item: ModuleNavItem | AllowedSidebarNavItem
): AppMenuNavGroup {
  if ('navGroup' in item && item.navGroup) {
    return item.navGroup
  }

  return SUPPORT_SLUGS.has(item.slug) ? 'suporte' : 'principal'
}

export function groupAppMenuNavItems(items: AllowedSidebarNavItem[]) {
  return items.reduce(
    (groups, item) => {
      const group = getAppMenuNavGroup(item)
      groups[group].push(item)
      return groups
    },
    {
      principal: [] as AllowedSidebarNavItem[],
      suporte: [] as AllowedSidebarNavItem[]
    }
  )
}
